module.exports = __webpack_public_path__ + "media/images/suppliers/elabscience-31f2f4c6854c6a0262f044edb785d308.png";